import SVG from "react-inlinesvg";
import { SudoButton } from "src/sudokit/components/SudoButton";
import ProTip from "../shared/ProTip/";
import SubBrainform from "../shared/SubBrainform";
import { PROTIPS } from "../staticData";
import { StyledBrainform, StyledBrainPuppet, StyledH3s } from "./styles";

const Brainform = ({
  enabled,
  submitting,
  userInteracted,
  update,
  proTip,
  setProTip,
  showProTip,
  setShowProTip,
  seenTips,
  setSeenTips,
  starters,
  setStarters,
  currentScreen,
  setPrompt,
  setContext,
  prompt,
  context,
  setKeepers,
  setItems,
  setQueuedItems,
  promptPlaceholder,
  randomizeExample,
  setHasEditedStarters,
  hasEditedStarters,
}) => {
  const handleSeenTip = (tip) => {
    setSeenTips([...seenTips, tip]);
    setShowProTip(false);
  };

  return (
    <>
      {showProTip && (
        <ProTip
          {...PROTIPS[proTip]}
          header="Pro Tip"
          setShowProTip={setShowProTip}
          success={() => handleSeenTip(proTip)}
        />
      )}
      <StyledBrainform>
        <StyledBrainPuppet>
          <SVG src="/assets/brainstorm/kickstart-brain.svg" />
        </StyledBrainPuppet>
        <StyledH3s>
          <h3>What kind of ideas are you looking for?</h3>
          <h3>The more detail, the better.</h3>
        </StyledH3s>
        <SubBrainform
          starters={starters}
          setStarters={setStarters}
          userInteracted={userInteracted}
          update={update}
          setShowProTip={setShowProTip}
          setProTip={setProTip}
          currentScreen={currentScreen}
          seenTips={seenTips}
          setPrompt={setPrompt}
          setContext={setContext}
          prompt={prompt}
          context={context}
          showExamples={true}
          setItems={setItems}
          setQueuedItems={setQueuedItems}
          setKeepers={setKeepers}
          promptPlaceholder={promptPlaceholder}
          showRandomButton={true}
          randomizeExample={randomizeExample}
          hasEditedStarters={hasEditedStarters}
          setHasEditedStarters={setHasEditedStarters}
        />
        {submitting && <button disabled={true}>Thinking...</button>}
        {!submitting && (
          <SudoButton
            variant="primary"
            disabled={!enabled}
          >
            Start
          </SudoButton>
        )}
      </StyledBrainform>
    </>
  );
};

export default Brainform;
